import './dropdown.css';

function Dropdown({
    itens = [],
    value = '',
    placeholder = 'Selecione...',
    onChange = () => {},
    onSelect = () => {},
    disabled = false,
    className = ''
}) {
    const safeItems = Array.isArray(itens) ? itens : [];

    const getItemValue = (item, index) => {
        if (item && typeof item === 'object') {
            return item.value ?? item.id ?? item.key ?? String(index);
        }
        return item;
    };

    const getItemLabel = (item) => {
        if (item && typeof item === 'object') {
            return item.label ?? item.fullName ?? item.name ?? item.nome ?? item.title ?? String(item.value ?? item.id ?? '');
        }
        return String(item ?? '');
    };

    const handleChange = (e) => {
        const selectedValue = e.target.value;
        const selectedItem = safeItems.find((item, index) => String(getItemValue(item, index)) === selectedValue);

        onChange(e);
        onSelect(selectedItem ?? selectedValue);
    };

    return (
        <div className={`dropdown-container ${className} ${disabled ? 'is-disabled' : ''}`.trim()}>
            <select
                className={`dropdown-select`}
                value={value}
                disabled={disabled}
                onChange={handleChange}
            >
                {placeholder && (
                    <option value='' disabled>
                        {placeholder}
                    </option>
                )}
                {safeItems.map((item, index) => {
                    const itemValue = getItemValue(item, index);
                    const itemLabel = getItemLabel(item);

                    return (
                        <option key={`${itemValue}-${index}`} value={itemValue}>
                            {itemLabel}
                        </option>
                    );
                })}
            </select>
            <span className='dropdown-caret' aria-hidden='true' />
        </div>
    );
}

export default Dropdown;